import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import {
  BaseCssProperties,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import * as Handlebars from 'handlebars';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-upload-file-with-popup',
  templateUrl: './upload-file-with-popup.component.html',
  styleUrl: './upload-file-with-popup.component.scss',
})
export class UploadFileWithPopupComponent implements OnInit {
  @Input() transactionId: string;
  @Input() isLoading = false;
  @Output() uploadFileCallback = new EventEmitter<File>();
  public textContent = 'Upload';
  public uploadFileIcon: string | undefined;
  public iconSize: baseCssConfigStyle;
  public supportedFileType = 'image/*';
  public allSupportedFileType = '.pdf,image/*';
  public maxFileUpload = '2';
  public fileUploads = '';
  public isOptionShown = false;
  public renderedTemplate: string;
  private attri: UiZoneWidgetAttributeConfig;
  public contentStyle: baseCssConfigStyle;

  constructor(
    private configService: ConfigService,
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
    private alertHandlerService: AlertHandlerService,
  ) {
    if (this.dataIn != undefined) {
      this.attri = this.dataIn.attri;
    }
  }
  ngOnInit() {
    this.maxFileUpload = this.attri?.['maxFileUpload'] ?? this.maxFileUpload;
    this.textContent = this.attri?.['widgetProperties']?.['textContent']
      ? this.attri?.['widgetProperties']?.['textContent']
      : this.textContent;

    if (this.dataIn != undefined) {
      this.renderedTemplate = Handlebars.compile(this.textContent)({});

      this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
        BaseCssProperties.MARGIN,
        BaseCssProperties.PADDING,
        BaseCssProperties.BORDER,
        BaseCssProperties.V_ALIGN,
        BaseCssProperties.TEXTALIGN,
        BaseCssProperties.BACKGROUND_COLOR,
        BaseCssProperties.COLOR,
        BaseCssProperties.BOX_SHADOW,
        BaseCssProperties.FONT_SIZE,
        BaseCssProperties.TEXT_BOLD,
        BaseCssProperties.TEXT_ITALIC,
        BaseCssProperties.TEXT_UNDERLINE,
      ]);
      this.iconSize = this.configService.getSpecificBaseCssStyle(this.attri, [BaseCssProperties.ICON_SIZE]);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onChangeFileInput(event: any) {
    this.isOptionShown = false;
    const filesUploaded = event.target.files.length;
    if (filesUploaded <= this.maxFileUpload) {
      this.prepareFile(event.target.files);
    } else {
      this.alertHandlerService.showAlertFn('error', 'You can select max' + this.maxFileUpload + ' files');
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private prepareFile(files: Array<any>) {
    for (const item of files) {
      item.hasSizeError = false;
      item.progress = 0;

      const fileSize = Math.round(item.size / 1024 / 1024);
      if (fileSize >= 10) {
        const msg = 'Cant upload ' + item.name + ', it exceeds the limit of 10 MB.';
        this.alertHandlerService.showAlertFn('error', msg);
        item.hasSizeError = true;
        return;
      }
    }
    this.uploadFileCallback.emit(files[0]);
  }
}
